export interface DataInfo {
  version: string;
  dataUpdated: Date;
}
